import { styled } from "@mui/material/styles";
import { Chip as MuiChip } from "@mui/material";

export const CustomTag = styled(MuiChip)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",

  borderRadius: "6.25rem",
  border: '1px solid transparent',

  backgroundColor: theme.colors["neutral.800"],
  
  color: theme.colors["neutral.50"],
  
  ".MuiChip-label": {
    padding: 0,
    
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.semibold,
    lineHeight: theme.lineHeights.base,
  },
  
  "&:hover": {
    backgroundColor: theme.colors["neutral.800"],
    border: `1px solid ${theme.colors["neutral.500"]}`
  },

  ".MuiChip-deleteIcon" : {
    color: theme.colors["lime.950"],
    margin: 0,
  },

  "&.active": {
    color: theme.colors["lime.950"],
    backgroundColor: theme.colors["lime.500"],
  }
}));